import Dropdown from "../../../common/dropdown/Dropdown";
import Input from "../../../common/input/Input";
import Modal from "../../../common/modal/Modal";
import EditOrderOptions from "./EditOrderOptions";
import { getDefaultDishOptionsByName, getDishOptionsByName } from "../../../../utils/model/lunch";
import './EditOrderModal.scss';
import { getFullName } from "../../../../utils/model/user";

const EditOrderModal = ({
                            onClose,
                            userOrder,
                            options,
                            onChange,
                            onSubmit
                        }) => {
    const {firstName, lastName, dish: selectedDish, additionalInfo = ''} = userOrder;
    const handleDishNameChange = ({text}) => {
        const newOptions = getDefaultDishOptionsByName(options, text);
        const newUserOrder = {...userOrder, dish: {name: text, options: newOptions}};
        onChange(newUserOrder);
    };
    const handleDishOptionsChange = (options) => {
        const newUserOrder = {...userOrder, dish: {...userOrder.dish, options}};
        onChange(newUserOrder);
    };
    const handleAdditionalInfoChange = (value) => {
        onChange({...userOrder, additionalInfo: value});
    };

    const orderOptions = options.map(el => ({key: el.value, text: el.name}));
    const isMenuWithDishes = !!orderOptions && orderOptions.length > 0;
    const dishOptions = isMenuWithDishes && getDishOptionsByName(options, selectedDish.name);
    const hasDishOptions = !!dishOptions && dishOptions.length > 0;
    return (
        <Modal isOpen>
            <div className="edit-order-modal">
                <div className="close-button" onClick={onClose}/>
                <p className="edit-order-modal__title">{getFullName(firstName, lastName)} has ordered:</p>
                <div>
                    {isMenuWithDishes && (
                        <Dropdown
                            label="Please select a dish..."
                            items={orderOptions}
                            selectedText={selectedDish.name}
                            onChange={handleDishNameChange}
                        />
                    )}
                    {hasDishOptions &&
                    <EditOrderOptions
                        onChange={handleDishOptionsChange}
                        selectedOptions={selectedDish.options}
                        options={dishOptions}
                    />
                    }
                    <Input
                        id="additionalInfo"
                        name="additionalInfo"
                        placeholder="Additional info"
                        value={additionalInfo}
                        onChange={handleAdditionalInfoChange}
                    />
                    <button className="default-button" onClick={onSubmit}>Update</button>
                </div>
            </div>
        </Modal>
    );
}

export default EditOrderModal;
